import React, { useState } from "react";
import styled from "styled-components";
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function MemberPlusBox(props) {
  const { data, onClick } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isHover, setIsHover] = useState(false);

  return (
    <PlusBox
      isHover={isHover}
      subBackground={theme.subBackground}
      subKey={theme.subKey}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onClick(data)}>
      <Plus isHover={isHover} width={10} height={2} subBackground={theme.subBackground} subKey={theme.subKey} />
      <Plus isHover={isHover} width={2} height={10} subBackground={theme.subBackground} subKey={theme.subKey} />
    </PlusBox>
  );
}

const PlusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  border-radius: 20px;
  background-color: ${props => props.isHover ? props.subKey : props.subBackground};

  &:hover {
    cursor: pointer;
  }
	
  transition: all 0.3s ease-in-out;
`;

const Plus = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  background-color: ${props => props.isHover ? props.subBackground : props.subKey};

  &:hover {
    cursor: pointer;
  }
	
  transition: all 0.3s ease-in-out;
`;
